import { AspectRatio, Box, Image } from "@chakra-ui/react";
import SelectionIndicator from "components/SelectionIndicator";
import TraitImage from "components/TraitImage";
import { defaultBearColor, publicUrl } from "config";
import { ImageSize, TraitCategory } from "types";
import { getTraitCategory } from "utils/traitsUtils";

type TraitCardProps = {
  tokenId: number;
  color?: number;
  imageSize?: ImageSize;
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick?: (tokenId: number) => void;
};

const TraitCard: React.FC<TraitCardProps> = ({
  tokenId,
  color = defaultBearColor,
  imageSize,
  children,
  isSelected = false,
  isDisabled = false,
  onClick,
}) => {
  const category = getTraitCategory(tokenId);

  return (
    <Box
      bg="bright.300"
      p="2"
      w="full"
      outline="2px solid"
      userSelect="none"
      outlineColor={isSelected ? "dark.base" : "transparent"}
      cursor={isDisabled ? "not-allowed" : onClick ? "pointer" : "default"}
      transition="all 0.15s"
      tabIndex={onClick ? 0 : undefined}
      onClick={() => {
        if (!isDisabled && onClick) {
          onClick(tokenId);
        }
      }}
    >
      <Box position="relative">
        <SelectionIndicator
          position="absolute"
          top="-2"
          left="-2"
          isSelected={isSelected}
          bg="bright.300"
        />

        <AspectRatio ratio={1} w="full" bg="bright.600">
          <>
            <Image
              src={`${publicUrl}/bear-placeholder_transparent.png`}
              w="full"
              transition="opacity 0.15s"
              position="absolute"
              zIndex={category === TraitCategory.Background ? 10 : 0}
            />
            <TraitImage
              tokenId={tokenId}
              color={color}
              size={imageSize}
              position="absolute"
              zIndex={5}
            />
          </>
        </AspectRatio>
      </Box>

      <Box pt="2">{children}</Box>
    </Box>
  );
};

export default TraitCard;
